import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonQualificationsCrumbs } from 'system/constants/common-qualifications-crumbs';
import OperatorDetail from 'system/components/operators/detail';
import { useParams, useNavigate, generatePath } from 'react-router';

const OperatorDetailPageQualificationsEdit = (): React.ReactElement => {
  const params = useParams();
  const navigate = useNavigate();

  const onCancel = useCallback(() => {
    navigate(generatePath('/sistema/qualifiche/modifica/:id', params));
  }, [navigate]);

  return (
    <Fragment>
      <Breadcrumbs
        items={[
          ...CommonQualificationsCrumbs,
          { name: 'Modifica Qualifica', path: '/sistema/qualifiche/modifica/:id' },
          { name: 'Dettaglio Operatore' },
        ]}
      />
      <OperatorDetail onCancel={onCancel} id={params.idOperatore} />
    </Fragment>
  );
};

OperatorDetailPageQualificationsEdit.displayName =
  'Operator Edit page component from Qualifications edit';

export default OperatorDetailPageQualificationsEdit;
